import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox,
  FDStack,
  FDConfirmationDialog,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const HouseholdSectionMemberLayout = () => {
  const { onSubmit, saving } = useMetaLayoutContext();

  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  return (
    <FDBox>
      <FDStack spacing={2} direction={'column'}>
        <MetaField
          attr={'statusId'}
          onChange={() => setConfirmDialogOpen(true)}
        />
        <MetaField
          attr={'sourceId'}
          onChange={onSubmit}
        />
        <MetaField
          attr={'sourceTypeId'}
          onChange={onSubmit}
        />
      </FDStack>
      <FDConfirmationDialog
        message={'Are you sure you want to update the client\'s status?'}
        title={'Are you sure?'}
        loading={saving}
        open={confirmDialogOpen}
        onConfirm={async () => {
          setConfirmDialogOpen(false);
          await onSubmit();
        }}
        onClose={() => setConfirmDialogOpen(false)}
      />
    </FDBox>
  );
};

HouseholdSectionMemberLayout.propTypes = {
};

export default HouseholdSectionMemberLayout;
